<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="560" scrollable persistent>
      <v-form ref="form" lazy-validation>
        <v-card class="rounded-lg">
          <v-card-title> ทดสอบส่ง อีเมล <v-spacer></v-spacer> </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6">
            <v-layout row wrap justify-center align-center>
              <v-flex xs8 lg8 pt-6>
                <v-text-field
                  v-model="email"
                  label="Email"
                  :rules="[rules.required, rules.email]"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-5 pa-3">
            <v-spacer></v-spacer>
            <v-btn color="#077893" dark @click="fn_save">
              {{ $t("onechat.send2") }}
            </v-btn>
            <v-btn color="error" outlined @click="Fn_Close">
              {{ $t("consentform.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import authorization from "@/functions/authorization.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_Content", "_SubjectEmail", "_NameTemplate"],
  data: function () {
    return {
      email: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogTemplateEmailTest");
        }
      },
    },
  },
  methods: {
    async fn_save() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        Receiver: this.email,
        SubjectEmail: this._SubjectEmail,
        NameTemplate: this._NameTemplate,
        HtmlEmail: this._Content,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/SampleEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: this.$t("email.statusSend"),
            });
            // this.$router.push("/email-template-index");
            this.Fn_Close();
          } else {
            Toast.fire({
              icon: "error",
              title: "' " + response.data.ErrorMessage + " '",
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Close() {
      this.$emit("closeDialogTemplateEmailTest");
    },
  },
  watch: {},
};
</script>
